import React, { lazy, Suspense } from "react";
import { useLanguage } from "../../utils/LanguageContext";
import HomeHelmet from "./components/HomeHelmet";
import HomeСarousel from "./components/HomeСarousel";

import "../../style/home.css";

const HomePartners = lazy(() => import("./components/HomePartners"));

const Home = () => {
  const { languageSlug } = useLanguage();

  return (
    <div style={{ width: "100%" }}>
      <HomeHelmet lang={languageSlug} />
      <HomeСarousel lang={languageSlug} />
      <Suspense fallback={null}>
        <HomePartners lang={languageSlug} />
      </Suspense>
    </div>
  );
};

export default Home;
